import React from 'react';
import DateRangeFilterPanel from './DateRangeFilterPanel';

import { omit } from 'lodash';

const MonthRangeFilterPanel = props => <DateRangeFilterPanel granularity="month" {...props} />;

MonthRangeFilterPanel.propTypes = omit(DateRangeFilterPanel.propTypes, 'granularity');
MonthRangeFilterPanel.defaultProps = omit(DateRangeFilterPanel.defaultProps, 'granularity');

export default MonthRangeFilterPanel;
